import type { CardCategory, UserSettings } from './types';

export const CATEGORIES: Record<string, CardCategory> = {
  energy:       { key: 'energy',       emoji: '🔋', label: 'Energy & Sensory', color: '#7C9885' },
  needs:        { key: 'needs',        emoji: '🙏', label: 'Needs',            color: '#8B7EA8' },
  availability: { key: 'availability', emoji: '📡', label: 'Availability',     color: '#6B8FAD' },
  emotional:    { key: 'emotional',    emoji: '💚', label: 'Emotional',        color: '#A8976B' },
  connection:   { key: 'connection',   emoji: '💜', label: 'Connection',       color: '#AD6B8F' },
};

export const QUICK_RESPONSES = ['Got it ✓', 'On my way', 'Take your time', 'Love you'] as const;

export const MAX_CIRCLE_MEMBERS = 6;
export const MAX_ACTIVE_CARDS_PER_USER = 3;
export const SENT_CARD_RETENTION_DAYS = 7;
export const JWT_EXPIRY_DAYS = 7;
export const INVITE_CODE_LENGTH = 12;
export const PUSH_COOLDOWN_SECONDS = 60;
export const PUSH_DAILY_CAP = 10;

export const DEFAULT_USER_SETTINGS: UserSettings = {
  theme: 'dark',
  reduce_motion: false,
  high_contrast: false,
  font_size: 'default',
  card_size: 'comfortable',
  haptic_feedback: true,
  sound_enabled: false,
  notifications: {
    push_enabled: false,
    soft_behaviour: 'badge',
    firm_behaviour: 'visible_sound',
    re_nudge_enabled: true,
    re_nudge_delay_minutes: 15,
    re_nudge_max: 1,
  },
  quiet_hours: null,
  partner_display_name: null,
  first_card_at: null,
  bmac_prompt_shown: false,
};

export const COLOUR_PALETTE = [
  '#7C9885', '#8B7EA8', '#6B8FAD', '#A8976B', '#AD6B8F',
  '#D4A34A', '#5A7D8C', '#C97B7B',
];

// UI timing constants — kept here so they stay in sync across components
export const TOAST_DURATION_MS = 2400;     // auto-remove delay in Toast store
export const COPY_RESET_MS = 1500;         // "Copied!" label reset in InviteQR
export const LONG_PRESS_MS = 500;          // long-press activation in CardTile
export const MS_PER_DAY = 86_400_000;      // elapsed-days calculation in BmacPrompt
export const BMAC_DAYS_THRESHOLD = 30;     // days after first send before showing BMAC prompt
export const WS_BASE_BACKOFF_MS = 1_000;   // WebSocket reconnect starting delay
export const WS_MAX_BACKOFF_MS = 30_000;   // WebSocket reconnect ceiling

export const EMOJI_PICKER = [
  '🔋', '🪫', '⚡', '💤', '😴', '🧘', '🌙', '☕',
  '🙏', '🤲', '🤝', '🫂', '💖', '💕', '💗', '💝',
  '📡', '📶', '🚦', '⏰', '⏳', '📅', '🕐', '🛑',
  '💚', '💛', '🧡', '❤️', '💜', '🤍', '🖤', '💙',
  '😊', '🥰', '😌', '😅', '😶', '😬', '😔', '😢',
  '😰', '😡', '🤯', '😵', '🌧️', '☀️', '🌈', '⭐',
  '🍎', '🥗', '🍵', '🥤', '🍫', '🍰', '🎂', '🍪',
  '🏃', '🧎', '💃', '🕺', '🎵', '🎶', '🎧', '📚',
  '💭', '💬', '👀', '👋', '✨', '🌟', '🔥', '🌸',
  '🐢', '🐈', '🦋', '🌿', '🌳', '🌊', '🪐', '🌠',
];
